// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { HttpService } from './http.service';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_KEY } from '@app/core/environment.configuration';
import { ScopeCategory } from '@app/core';
import { Role, RoleDetail } from '../models';
import { RoleDetailsFacadeService } from '@app/access-management/state/role-details.facade';

@Injectable()
export class OrganizationService {
  constructor(private httpClient: HttpClient, @Inject(API_KEY) private api: string, private httpService: HttpService) {}

  public getList(): Observable<ScopeCategory[]> {
    const route = `${this.api}/roles/scopes/2`;
    return this.httpClient.get<ScopeCategory[]>(route).pipe(map(response => response));
  }

  public get(orgId: string): Observable<ScopeCategory> {
    const route = `${this.api}/roles/scopes/2/scopetype/${orgId}`;
    return this.httpClient.get<ScopeCategory>(route).pipe(map(response => response));
  }

  public getOrgRoles(orgId: string, roleId: string): Observable<RoleDetail> {
    const route = `${this.api}/accounts/${orgId}/roles`;
    return this.httpClient.get(route).pipe(
      map(
        (response: Role[]) =>
          response &&
          response.map(role => {
            if (role.id === roleId) {
              return {
                ...role
              };
            }
          })
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/organization.service.ts